import { MouseEventHandler, useEffect, useState } from 'react';
import styled from 'styled-components';
import { Flex } from '@motili/ui';

import MotiliButton from 'common/components-v2/buttons/MotiliButton';
import Drawer from 'common/components-v2/modal/Drawer';
import { generateRandomUUID } from 'common/utils/Utils';
import MotiliButtonContainer from '../buttons/MotiliButtonContainer';

const baseCDNURL = 'https://static.motili.com/images/photoRequirements/';

const Image = styled.img`
    width: 100%;
    display: inline;
    object-fit: contain;
`;

const Description = styled.div`
    font-size: 16px;
`;

const DrawerTitle = styled.div`
    font-size: 24px;
    font-weight: 600;
    color: #333333;
`;
interface DocumentRequirementsRecommendationDrawerProps {
    photoTypeId: string;
    photoTypes: {
        id: string;
        display: string;
        imageNames: string[];
        description: string;
    }[];
    handleCloseOnClick: MouseEventHandler<HTMLElement>;
    open: boolean;
}
const DocumentRequirementsRecommendationDrawer = ({
    photoTypeId,
    photoTypes,
    handleCloseOnClick,
    open,
}: DocumentRequirementsRecommendationDrawerProps) => {
    const {
        imageNames = [],
        display,
        description,
    } = photoTypes?.find(photoType => photoType.id === photoTypeId) || {};
    const [uuid, setUuid] = useState<string | undefined>();
    useEffect(() => {
        if (open) {
            setUuid(generateRandomUUID());
        }
    }, [open]);
    return (
        <Drawer
            drawerStyle={{
                maxWidth: '45%',
                paddingBottom: '75px',
            }}
            title={<DrawerTitle>{display || 'Other'}</DrawerTitle>}
            onClose={handleCloseOnClick}
            closeByDocument
            showClose
            open={open}
        >
            <Flex key={uuid} direction='column' gap='20px'>
                {imageNames.map(imageName => (
                    <Image src={baseCDNURL + imageName} />
                ))}

                {description && <Description>{description}</Description>}
            </Flex>
            <MotiliButtonContainer
                styles={{
                    marginTop: '40px',
                }}
            >
                <MotiliButton text='Close' onClick={handleCloseOnClick} />
            </MotiliButtonContainer>
        </Drawer>
    );
};

export default DocumentRequirementsRecommendationDrawer;
